import React, { useState } from "react"
import TransactionItem from "../../components/TransactionItem"

import { TRANSACTION_TYPES } from "./constants"
import {
  ContentContainer,
  DateHistory,
  DatesHistory,
  MonthContainer,
  MonthDropdownButton,
  MonthDropdownContainer,
  MonthText,
  Toggle,
  ToggleGroup,
  ToggleGroupContainer,
  TransactionDate,
  UploadHistoryButton,
} from "./styled"

const History = () => {
  const [selectedTransactionType, setSelectedTransactionType] = useState(
    TRANSACTION_TYPES.WRITE_OFF,
  )

  const handleChangeTransactionType = (
    event: React.MouseEvent<HTMLElement>,
    nextView: string,
  ) => {
    setSelectedTransactionType(nextView)
  }

  return (
    <ContentContainer>
      <ToggleGroupContainer>
        <ToggleGroup value={selectedTransactionType}>
          <Toggle
            value={TRANSACTION_TYPES.WRITE_OFF}
            aria-label={TRANSACTION_TYPES.WRITE_OFF}
            onClick={handleChangeTransactionType}
          >
            Списания
          </Toggle>
          <Toggle
            value={TRANSACTION_TYPES.REPLENISHMENT}
            aria-label={TRANSACTION_TYPES.REPLENISHMENT}
            onClick={handleChangeTransactionType}
          >
            Пополнения
          </Toggle>
        </ToggleGroup>
        <UploadHistoryButton>Детализация</UploadHistoryButton>
      </ToggleGroupContainer>
      <MonthContainer>
        <MonthDropdownContainer>
          <MonthText>За</MonthText>
          <MonthDropdownButton>август</MonthDropdownButton>
        </MonthDropdownContainer>
        <MonthText>11 200 ₽</MonthText>
      </MonthContainer>
      <DatesHistory>
        <DateHistory>
          <TransactionDate>сегодня</TransactionDate>
          <TransactionItem
            source="Cбербанк"
            time="11:22"
            description="Перевод"
            amount={10000}
          />
          <TransactionItem
            source="Cбербанк"
            time="11:22"
            description="Перевод"
            amount={20000}
          />
          <TransactionItem
            source="Cбербанк"
            time="11:22"
            description="Перевод"
            amount={30000}
          />
        </DateHistory>
      </DatesHistory>
    </ContentContainer>
  )
}

export default History
